export default "__VITE_ASSET__58ead6a4__"